module.exports = __webpack_public_path__ + "static/media/MF.de42f245.svg";